import Section from "../components/Section";
import Card from "../components/Card";
import projects from "../data/Projects";
function Projects() {
  return (
    <Section>
      {" "}
      <h2 className="text-3xl text-blue-600 font-bold text-center mb-8">
        <strong className=" text-orange-400"> Mes </strong>Projets
      </h2>{" "}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {" "}
        {projects.map((project) => (
          <Card
            key={project.id}
            title={project.title}
            description={project.desc}
            image={project.image}
          />
        ))}{" "}
      </div>{" "}
    </Section>
  );
}
export default Projects;
